export interface IOkWebView {
    open: (stringifiedResponse?: string) => void;
    onBack: () => void;
    onAppMessage: (stringifiedResponse: string) => void;
    navigateToNativePage: (url: string) => void;
    backOrCloseLayer: () => void;
}

export interface NavigationEvent extends Event {
    detail?: { url: string, handleOnNavigationStart?: boolean };
}

export enum NavigationEventType {
    ON_NAVIGATION_START = 'onNavigationStart',
    ON_NAVIGATION_END = 'onNavigationEnd',
    ON_NAVIGATION_FAILED = 'onNavigationFailed',
}
